import React from "react";

type Props = {
    yoto_naiyo1: string;
    yoto_menseki1: string;
    yoto_naiyo1_error?: string;
    yoto_menseki1_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const InputKenchikuYoto = ({
                                      yoto_naiyo1,
                                      yoto_menseki1,
                                      yoto_naiyo1_error,
                                      yoto_menseki1_error,
                                      setValue
                                  }: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">建築物用途</div>
            <div className="form-flex-input form-flex-input-2col">
                <div className="form-flex-column">
                    <label className="form-flex-input-in-2col">
                        <span>用途</span>
                        <input type="text" name="yoto_naiyo1" placeholder="事務所" required
                               className={yoto_naiyo1_error ? 'form-input-error' : ''}
                               value={yoto_naiyo1}
                               onChange={(e) => setValue('yoto_naiyo1', e.target.value)}
                        />

                    </label>
                    {yoto_naiyo1_error && <div className="form-error-message">{yoto_naiyo1_error}</div>}
                </div>

                <div className="form-flex-column">
                    <label className="form-flex-input-in-2col">
                        <span>延床面積</span>
                        <input type="text" name="yoto_menseki1" inputMode="decimal" placeholder="240㎡" required
                               className={yoto_menseki1_error ? 'form-input-error' : ''}
                               value={yoto_menseki1}
                               onChange={(e) => setValue('yoto_menseki1', e.target.value)}
                        />
                    </label>
                    {yoto_menseki1_error && <div className="form-error-message">{yoto_menseki1_error}</div>}
                </div>
            </div>
        </div>
    );
};
